import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { Table, UnidataTable } from '~/components';
import { MODULO_CUSTOMIZACAO_VLI } from '~/constants/modules';
import { can, t } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';
import { handleExportGeneric } from '~/helpers/exportReports';
import api from '~/services/api';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/pitStopRegra/actions';

import Form from './form';
import * as S from './styles';

function PitStopRegra() {
  const [loadingItens, setLoadingItens] = useState(false);
  const [itens, setItens] = useState([]);

  const redux = useSelector((state) => state.pitStopRegra);
  const clienteVli = can(MODULO_CUSTOMIZACAO_VLI);

  // const header = useMemo(() => [], []);

  const options = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  const cellsItens = useMemo(
    () => [
      {
        id: 'descricaoobservacaoatendimentoitem',
        label: t('s.cadastro.pitstop.descricaoobservacao'),
      },
      {
        id: 'statusobservacaoatendimentoitem',
        label: t('s.cadastro.pitstop.statusobservacao'),
        format: (value) => options.find((s) => s.label === value)?.value || '',
      },
    ],
    [options]
  );

  const header = useMemo(
    () => [
      {
        id: 'descricaoobservacao',
        label: t('s.cadastro.pitstop.descricaoobservacao'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const fieldlist = ['descricaoobservacao'];

  const substituirHeader = {
    descricaoobservacao: t('s.cadastro.pitstop.descricaoobservacao'),
  };

  const handleResponseDataItems = useCallback(
    async (idobservacaoatendimento) => {
      if (!clienteVli || !idobservacaoatendimento) {
        return;
      }

      try {
        setLoadingItens(true);
        const { data } = await api.get(
          `observacaoatendimento/regra/${idobservacaoatendimento}/itens`
        );
        setItens(data);
      } catch (err) {
        getToastErrors(err);
      } finally {
        setLoadingItens(false);
      }
    },
    [clienteVli]
  );

  useEffect(() => {
    if (redux.loading) {
      setItens([]);
    }
  }, [redux.loading]);

  return (
    <S.Container>
      <UnidataTable
        fixed
        // title={t('s.menu.configuracao.pitstop.regra')}
        redux={redux}
        header={header}
        read={recordFiltering}
        find={findData}
        remove={deleteData}
        form={Form}
        keys="idobservacaoatendimento"
        detach="idobservacaoatendimento"
        {...(clienteVli
          ? {
              onRow: (value) =>
                handleResponseDataItems(value.idobservacaoatendimento),
              maxHeight: '60vh',
            }
          : {})}
        pdf
        excel
        onExport={(formato) =>
          handleExportGeneric({
            endpoint: 'observacaoatendimento/regra',
            formato,
            fields: fieldlist,
            headers: substituirHeader,
            redux,
            ordination: redux.params.ordination,
            orderfield: redux.params.orderfield,
            title: t('s.menu.configuracao.pitstop.regra'),
            substituirValores: {},
          })
        }
      />

      {clienteVli && (
        <S.Wrapper grids="1">
          <Table
            title={t('s.configuracao.arqueacao.itens')}
            isResponsive
            size="small"
            height="18rem"
            paginate={99}
            showPagination={false}
            cells={cellsItens}
            data={itens}
            loading={loadingItens}
          />
        </S.Wrapper>
      )}
    </S.Container>
  );
}

export default PitStopRegra;
